import { render, staticRenderFns } from "./PointsOfInterest.vue?vue&type=template&id=10282c2d&scoped=true&"
import script from "./PointsOfInterest.vue?vue&type=script&lang=js&"
export * from "./PointsOfInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10282c2d",
  null
  
)

export default component.exports